<template>
  <v-container grid-list-sm>
    <v-layout row wrap>
      <v-card elevation="0" class="pt-0">
        <v-card-text fill-height class="pt-0">
          <v-container fluid grid-list-sm class="pa-0">
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  label="Address"
                  v-model="fields.billing_address"
                  append-icon="fa-home"
                  box
                  hide-details
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="City"
                  v-model="fields.billing_city"
                  append-icon="fa-compass"
                  box
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <StateField
                  v-model="fields.billing_state"
                  icon="fa-info-circle"
                  :textfield="fields.billing_country !== 'USA'"
                ></StateField>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Postal Code"
                  v-model="fields.billing_postalcode"
                  :rules="schedule.request_type !== 'ach' ? postalcodeRules : []"
                  append-icon="fa-info-circle"
                  box
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Phone"
                  v-model="fields.billing_phone"
                  mask="(###) ###-####"
                  append-icon="fa-phone"
                  box
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Email"
                  v-model="fields.billing_email"
                  append-icon="fa-at"
                  :rules="emailRules"
                  box
                  hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-container fluid grid-list-lg class="pa-0">
            <v-layout row wrap>
              <v-spacer></v-spacer>
              <v-flex xs3>
                <v-btn block large @click="closeModal">Cancel</v-btn>
              </v-flex>
              <v-flex xs3>
                <v-btn block large @click="save" color="primary" :disabled="!submitDisabled">Confirm</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import Bus from '@/bus'

import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'
import UtilityMixin from '@/mixins/utility'

import StateField from '@/components/forms/StateDropdown.vue'

export default {
  components: { StateField },

  mixins: [
    ApiMixin,
    AuthMixin,
    DisplayMixin,
    StoreMixin,
    UtilityMixin
  ],

  data: function () {
    return {
      fields: {
        billing_address: '',
        billing_address_original: '',
        billing_city: '',
        billing_city_original: '',
        billing_state: '',
        billing_state_original: '',
        billing_postalcode: '',
        billing_postalcode_original: '',
        billing_country: '',
        billing_country_original: '',
        billing_phone: null,
        billing_phone_original: null,
        billing_email: null,
        billing_email_original: null
      },

      postalcodeRules: [
        (v) => !!v || 'Postal code is required'
      ],
      emailRules: [
        (v) => !v || /.+@.+/.test(v) || 'Email must be valid'
      ]
    }
  },

  props: {
    terminal: Object,
    schedule: Object
  },

  watch: {
    schedule: {
      handler () {
        this.load()
      },
      immediate: true
    }
  },

  computed: {
    submitDisabled: function () {
      return this.fields.billing_address !== this.fields.billing_address_original ||
        this.fields.billing_city !== this.fields.billing_city_original ||
        this.fields.billing_state !== this.fields.billing_state_original ||
        this.fields.billing_postalcode !== this.fields.billing_postalcode_original ||
        this.fields.billing_country !== this.fields.billing_country_original ||
        this.fields.billing_phone !== this.fields.billing_phone_original ||
        this.fields.billing_email !== this.fields.billing_email_original
    }
  },

  methods: {
    closeModal () {
      Bus.$emit('closeModifyModal')
    },

    async load () {
      this.fields.billing_address_original = this.fields.billing_address = this.schedule.billing_address
      this.fields.billing_city_original = this.fields.billing_city = this.schedule.billing_city
      this.fields.billing_state_original = this.fields.billing_state = this.schedule.billing_state
      this.fields.billing_postalcode_original = this.fields.billing_postalcode = this.schedule.billing_postal_code
      this.fields.billing_country_original = this.fields.billing_country = this.schedule.billing_country
      this.fields.billing_phone_original = this.fields.billing_phone = this.schedule.billing_phone
      this.fields.billing_email_original = this.fields.billing_email = this.schedule.billing_email
    },

    async save () {
      try {
        Bus.$emit('openWaitModal')

        let options = {}

        if (this.fields.billing_address !== this.fields.billing_address_original) {
          options.billing_address = this.fields.billing_address
        }
        if (this.fields.billing_city !== this.fields.billing_city_original) {
          options.billing_city = this.fields.billing_city
        }
        if (this.fields.billing_state !== this.fields.billing_state_original) {
          options.billing_state = this.fields.billing_state
        }
        if (this.fields.billing_postalcode !== this.fields.billing_postalcode_original) {
          options.billing_postalcode = this.fields.billing_postalcode
        }
        if (this.fields.billing_phone !== this.fields.billing_phone_original) {
          options.billing_phone = this.fields.billing_phone
        }
        if (this.fields.billing_email !== this.fields.billing_email_original) {
          options.billing_email = this.fields.billing_email
        }

        let result = await this.api({
          method: 'put',
          url: `/schedules/${this.schedule.id}`,
          data: options
        })

        if (result.data && !result.data.error) {
          Bus.$emit('openModal', {status: 'success', message: 'Billing Details Saved'})
          Bus.$emit('reloadPnxInstallment')
          this.closeModal()
        } else {
          throw new Error('Error while modifying billing details')
        }
      } catch (err) {
        Bus.$emit('openModal', {status: 'error', message: err})
      } finally {
        Bus.$emit('closeWaitModal')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pnxInstallments/ModifyBilling.vue